<template>
  <div>
    <question :idx="2">
      <p class="title">2、下列选项中，能实现房屋价值和房屋修缮资金来源的是（）</p>
      <ul>
        <li class="error"><span style="display: none">A</span><Icon type="md-close-circle" color="#ff3300"/>租金调整</li>
        <li><span>B</span>房屋保险赔偿</li>
        <li class="zhengque"><span style="display: none">C</span><Icon type="md-checkmark-circle" color="#009900"/>租金收入</li>
        <li><span>D</span>租金方案的实施</li>
      </ul>
      <Button  class="btn" @click="next">下一题</Button>
    </question>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
</style>
<script type="text/ecmascript-6">
  import question from '../template/question'
    export default {
        name: '',
        props: {},
        data() {
            return {};
        },
        methods: {
          next(){
            this.$router.push({
              path: '/que2'
            })
          }
        },
        created() {

        },
        components: {
          question
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/question/qus2.vue